import React from 'react';
import { CalendarDays, Users, Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyRecommendationStateProps {
  reason: 'no-dates' | 'no-matches' | 'all-filtered';
  onSwitchToManual: () => void;
}

const config = {
  'no-dates': {
    Icon: CalendarDays,
    heading: 'Set your booking dates first',
    sub: 'Resource suggestions appear once a start and end date are defined.',
    cta: null,
  },
  'no-matches': {
    Icon: Users,
    heading: 'No matching resources',
    sub: 'No resources fit the current booking criteria. Try adjusting dates, role, or location.',
    cta: 'Browse all resources',
  },
  'all-filtered': {
    Icon: Filter,
    heading: 'No results match your filters',
    sub: 'Clear one or more filters to see more suggestions.',
    cta: 'Browse all resources',
  },
};

export function EmptyRecommendationState({ reason, onSwitchToManual }: EmptyRecommendationStateProps) {
  const { Icon, heading, sub, cta } = config[reason];
  return (
    <div className="py-10 flex flex-col items-center gap-3 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted">
        <Icon className="h-5 w-5 text-muted-foreground" />
      </div>
      <div className="space-y-1">
        <p className="text-sm font-medium">{heading}</p>
        <p className="text-xs text-muted-foreground max-w-[240px] leading-relaxed">{sub}</p>
      </div>
      {cta && (
        <Button variant="outline" size="sm" onClick={onSwitchToManual}>
          {cta}
        </Button>
      )}
    </div>
  );
}
